<template>
  <div class="content-div">
    <el-form :rules="rules" ref="ruleForm" :model="drawerForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="配置名称" prop="deployName">
            <el-input :disabled="disableType" placeholder="请输入" v-model="drawerForm.deployName" size="mini" style="padding-top: 6px">
              <template slot="append">
                <div @click="openHistory" style="padding:0 20px">打开历史配置</div>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="ID类型" prop="canType">
            <el-select :disabled="disableType" v-model="drawerForm.canType" placeholder="请选择" style="width: 100%"
                       size="mini">
              <el-option
                  v-for="item in IDOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="CAN通道" prop="canChannel">
            <el-select :disabled="disableType" v-model="drawerForm.canChannel" placeholder="请选择" style="width: 100%"
                       size="mini">
              <el-option
                  v-for="item in CANOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="起始位" prop="startBit">
            <el-input
                :disabled="disableType"
                v-model="drawerForm.startBit"
                type="number"
                onkeypress="return(/^[0-9]*$/.test(String.fromCharCode(event.keyCode)))"
                placeholder="请输入"
                size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="数据类型" prop="dataType">
            <el-select :disabled="disableType" v-model="drawerForm.dataType" placeholder="请选择" style="width: 100%"
                       size="mini">
              <el-option
                  v-for="item in dataOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="长度(bit)" prop="bitLength">
            <el-input
                :disabled="disableType"
                v-model="drawerForm.bitLength"
                type="number"
                onkeypress="return(/^[0-9]*$/.test(String.fromCharCode(event.keyCode)))"
                placeholder="请输入" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="帧ID(OX)" prop="canId">
            <el-input :disabled="disableType" v-model="drawerForm.canId" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效值(OX)" prop="trms">
            <el-input :disabled="disableType" v-model="drawerForm.trms" placeholder="请输入" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: right">
        <el-button @click="resetType" size="mini">重置</el-button>
        <el-button @click="submitData(2)" size="mini" type="primary" plain>取消</el-button>
        <el-button :loading="submitType" @click="submitData(1)" type="primary" size="mini">确定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import {addDeploy} from "../../../common/signalConfigurationApi";

export default {
  name: "configurationDialog",
  props: {
    drawerForm: {
      type: Object,
    },
    dialogType: {
      type: Number
    },
    disableType: {
      type: Boolean
    },
    itemArrId: {
      type: Array
    },
    itemId: {
      type: Number
    },
    historyId: {
      type: Number
    }
  },
  data() {
    // 起始位校验
    var validateStartBit = (rule, value, callback) => {
      console.log(value)
      if (value && Number(value) >= 0 && Number(value) <= 63) {
        callback()
      } else {
        callback(new Error('请输入0-63的起始位'))
      }
    }
    // 长度(bit)校验
    var validateBitLength = (rule, value, callback) => {
      if (value && Number(value) >= 1 && Number(value) <= 8) {
        callback()
      } else {
        callback(new Error('请输入1-8的长度(bit)'))
      }
    }
    return {
      rules: {
        deployName: [
          {required: true, message: '请输入配置名称', trigger: 'blur'},
          {max: 20, message: '最多可输入20个字符', trigger: 'blur'}
        ],
        startBit: [
          {required: true, validator: validateStartBit, trigger: 'blur'}
        ],
        bitLength: [
          {required: true, validator: validateBitLength, trigger: 'blur'}
        ],
        canId: [
          {required: true, message: '请输入帧ID(OX)', trigger: 'blur'},
        ],
        trms: [
          {required: true, message: '请输入有效值(OX)', trigger: 'blur'},
        ],
        canType: [
          {required: true, message: '请选择ID类型', trigger: 'change'}
        ],
        canChannel: [
          {required: true, message: '请选择CAN通道', trigger: 'change'}
        ],
        dataType: [
          {required: true, message: '请选择数据类型', trigger: 'change'}
        ],
      },
      submitType: false,
      IDOptions: [
        {
          value: 0,
          label: '标准帧'
        },
        {
          value: 1,
          label: '扩展帧'
        }
      ],
      CANOptions: [
        {
          value: '0',
          label: '通道0'
        },
        {
          value: '1',
          label: '通道1'
        }
      ],
      dataOptions: [
        {
          value: 0,
          label: 'Intel'
        },
        {
          value: 1,
          label: 'Motorola LSB'
        }
      ],
    }
  },
  methods: {
    resetType() {
      this.$refs.ruleForm.resetFields();
      this.$emit('resetType')
    },
    async submitData(type) {
      console.log(this.drawerForm)
      if (type === 1) {
        /*
        * dialogType 枚举类型
        * 1  批量修改
        * 2  单独修改
        * */
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitType = true
            if (this.dialogType === 1) {
              try {
                /*
              * disableType 枚举类型
              * true  使用历史配置
              * false  使用自定义配置
              * */
                let param = {}
                if (this.disableType) {
                  param = {
                    id: this.historyId,
                    ids: this.itemArrId
                  }
                } else {
                  param = {
                    ...this.drawerForm,
                    ids: this.itemArrId
                  }
                }
                const res = await addDeploy(param)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '配置成功'
                  })
                  this.submitType = false
                  this.$emit('dialogClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            } else {
              try {
                /*
             * disableType 枚举类型
             * true  使用历史配置
             * false  使用自定义配置
             * */
                let param = {}
                if (this.disableType) {
                  param = {
                    id: this.historyId,
                    ids: [this.itemId]
                  }
                } else {
                  param = {
                    ...this.drawerForm,
                    ids: [this.itemId]
                  }
                }
                const res = await addDeploy(param)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '配置成功'
                  })
                  this.submitType = false
                  this.$emit('dialogClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.$emit('dialogClose')
      }
    },
    // 打开历史配置
    openHistory() {
      this.$emit('openHistory')
    }
  }
}
</script>

<style scoped>
.content-div /deep/ .el-form-item__error {
  padding-top: 0 !important;
}

.content-div {
  padding: 0 40px;
}

.content-div /deep/ .el-input-group__append {
  background: #1890ff;
  padding: 0;
  cursor: pointer;
  color: #fff;
  user-select: none;
  font-weight: 700;
}
</style>
